import MedicationDeliveryEditStep, {
	IUpdateMemberDefaultMedicationDeliveryMethodArguments,
} from './MedicationDeliveryEditStep.component';
import MedicationDeliveryEditStepPage from './MedicationDeliveryEditStep.page';

export default MedicationDeliveryEditStepPage;

export { MedicationDeliveryEditStep };
export type { IUpdateMemberDefaultMedicationDeliveryMethodArguments };
